import React, { useEffect } from "react";
import { BeneBankHooksProps } from "../../types/hooks";
import i18n from "../../i18n/config";
import { BANK_ACCOUNT_FLOW_TYPES } from "../../constants/enums";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../constants/clientRoutes";
import { FORM_NAMES } from "../../constants/forms";
import { isValid } from "redux-form";
import { RootState } from "../../types/redux";
import { useSelector } from "react-redux";

const useBankDetailsInit = ({ enabled, setTitle, setSubTitle, setForwardButton, setLoading, type }: BeneBankHooksProps) => {
  const history = useHistory();
  const forwardButtonInitialState = { text: i18n.t("COMMON.CONFIRM"), clickFunc: () => history.push(ROUTES.BANKS_ACCOUNTS.REVIEW_ACCOUNT_DETAILS), disabled: false };
  const valid = useSelector((state: RootState) => isValid(FORM_NAMES.BANK_ACCOUNTS)(state));

  useEffect(() => {
    if (valid && enabled) {
      setForwardButton(forwardButtonInitialState);
    } else if (enabled && !valid) {
      setForwardButton({ ...forwardButtonInitialState, disabled: true });
    }
  }, [valid]);

  useEffect(() => {
    if (!enabled) return;

    window.scrollTo(0, 0);
    setLoading(false);

    const title = type === BANK_ACCOUNT_FLOW_TYPES.NEW ? i18n.t("PAGES.BANK_ACCOUNTS.BANK_DETAILS.ADD_NEW_TITLE") : i18n.t("PAGES.BANK_ACCOUNTS.BANK_DETAILS.EDIT_TITLE");
    const subtitle = type === BANK_ACCOUNT_FLOW_TYPES.NEW ? i18n.t("PAGES.BANK_ACCOUNTS.BENEFICIARY_BANK_DETAILS.ADD_NEW_SUBTITLE") : i18n.t("PAGES.BANK_ACCOUNTS.BENEFICIARY_BANK_DETAILS.EDIT_SUBTITLE");
    setTitle(title);
    setSubTitle(subtitle);
    setForwardButton(forwardButtonInitialState);
  }, [enabled]);
}

export default useBankDetailsInit;